import { ListToggle } from '../../components/list-toggle';

type ProjectToggleProps = {
	jiraProjectAri: string;
	onChange: (jiraProjectAri: string, value: boolean) => void;
	value: boolean;
	settingsError: string | null;
};

export const JiraProjectToggle = ({
	jiraProjectAri,
	onChange,
	value,
	settingsError,
}: ProjectToggleProps) => {
	const handleChange = () => {
		onChange(jiraProjectAri, !value);
	};

	return (
		<ListToggle
			onChange={handleChange}
			isChecked={value}
			analyticsEvent={{
				action: 'clicked',
				actionSubject: 'code-planner-jira-project-toggle',
				actionSubjectId: 'code-planner-jira-project-toggle',
				source: 'code-planner-settings',
			}}
			isDisabled={settingsError !== null}
		/>
	);
};
